import { agentGuideLink } from '../../agent/integration.js';
import { getManagerID, getManagerToken, getManagerName, clearAllManagedData } from '../utils/localStorageManager.js';
import { t } from '../language/pageTranslator.js';
import managerApi from '../api/manager.js';
import { showErrorToast, showSuccessToast } from '../utils/toast.js';
import { isTrainingMode, disableTrainingMode } from '../training/trainingMode.js';
let rootPrefix = '';
export function renderSharedHeader({ prefix = '', sidebar = true } = {}) {
    rootPrefix = prefix;
document.getElementById('header-container').innerHTML = `
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top wknd-agent-header">
    <div class="container-fluid">
        ${sidebar ? `<button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="offcanvas"
            data-bs-target="#sidebarOffcanvas" aria-controls="sidebarOffcanvas" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>` : ''}
        <a class="navbar-brand" href="${rootPrefix}index.html">
            <img src="${rootPrefix}img/wknd_appicon.png" alt="Logo" width="30" height="30"
                class="d-inline-block align-text-top me-2">
            <span class="wknd-brand-title">The WKND Club CMS</span>
        </a>
        <div class="d-flex align-items-center ms-auto wknd-header-actions" id="navbarNav">
            <ul class="navbar-nav ms-auto flex-row">
                <li class="nav-item">${agentGuideLink(rootPrefix)}</li>
                <li class="nav-item dropdown">
                    <button id="manager-name-display" class="btn btn-link navbar-text dropdown-toggle text-decoration-none me-3 p-0" type="button"
                        data-bs-toggle="dropdown" aria-expanded="false"></button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li><button class="dropdown-item" type="button" id="change-password-menu-item">修改密碼</button></li>
                    </ul>
                </li>
                <li class="nav-item">
                    <button id="logout-button" class="btn btn-outline-light">Logout</button>
                </li>
            </ul>
        </div>
    </div>
</nav>
<div class="modal fade" id="changePasswordModal" tabindex="-1" aria-labelledby="changePasswordModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <form id="changePasswordForm" autocomplete="off">
                <div class="modal-header wknd-modal-header">
                    <h5 class="modal-title wknd-modal-title" id="changePasswordModalLabel">修改密碼</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="oldPasswordInput" class="form-label">舊密碼</label>
                        <input type="password" class="form-control" id="oldPasswordInput" autocomplete="current-password" required>
                    </div>
                    <div class="mb-3">
                        <label for="newPasswordInput" class="form-label">新密碼</label>
                        <input type="password" class="form-control" id="newPasswordInput" autocomplete="new-password" required>
                    </div>
                    <div>
                        <label for="confirmNewPasswordInput" class="form-label">確認新密碼</label>
                        <input type="password" class="form-control" id="confirmNewPasswordInput" autocomplete="new-password" required>
                    </div>
                </div>
                <div class="modal-footer wknd-modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">取消</button>
                    <button type="submit" class="btn btn-primary" id="changePasswordSubmitBtn">儲存</button>
                </div>
            </form>
        </div>
    </div>
</div>
`;


}
export function initializeModalFocusManagement() {
    // 為所有現有的 Modal 添加焦點管理
    const modals = document.querySelectorAll('.modal');
    modals.forEach(modal => {
        modal.addEventListener('hide.bs.modal', () => {
            // 在 Modal 隱藏之前移除所有內部元素的焦點
            const focusedElement = modal.querySelector(':focus');
            if (focusedElement) {
                focusedElement.blur();
            }

            // 同時移除 Modal 元素本身的焦點
            if (document.activeElement === modal) {
                modal.blur();
            }

            // 如果任何子元素仍有焦點，將焦點移到 body
            if (modal.contains(document.activeElement)) {
                document.activeElement.blur();
                document.body.focus();
            }
        });
    });

    // 監聽動態創建的 Modal（使用事件委派）
    document.addEventListener('hide.bs.modal', (event) => {
        const modal = event.target;
        if (modal && modal.classList.contains('modal')) {
            const focusedElement = modal.querySelector(':focus');
            if (focusedElement) {
                focusedElement.blur();
            }

            // 同時移除 Modal 元素本身的焦點
            if (document.activeElement === modal) {
                modal.blur();
            }

            // 如果任何子元素仍有焦點，將焦點移到 body
            if (modal.contains(document.activeElement)) {
                document.activeElement.blur();
                document.body.focus();
            }
        }
    });
}

export function handleManagerAuth() {
    const managerNameDisplay = document.getElementById('manager-name-display');
    const logoutButton = document.getElementById('logout-button');
    const changePasswordMenuItem = document.getElementById('change-password-menu-item');

    const managerID = getManagerID();
    const token = getManagerToken();
    const managerName = getManagerName(); // 取得管理者名稱
    const training = isTrainingMode();

    if (changePasswordMenuItem) {
        changePasswordMenuItem.style.display = training ? 'none' : 'block';
    }

    if (managerID && token) {
        // 已登入狀態
        if (managerNameDisplay) {
            managerNameDisplay.textContent = managerName || managerID; // 優先顯示管理者名稱，否則顯示 ID
            managerNameDisplay.style.display = 'inline-block';
        }
        if (logoutButton) {
            logoutButton.style.display = 'inline-block';
            logoutButton.addEventListener('click', handleLogout);
        }
    } else {
        // 未登入狀態
        if (managerNameDisplay) {
            managerNameDisplay.textContent = '';
            managerNameDisplay.style.display = 'none';
        }
        if (logoutButton) {
            logoutButton.style.display = 'none';
        }
    }
}

/**
 * 處理登出操作
 * 清除所有管理員資料並重定向到登入頁面
 */
function handleLogout() {
    if (confirm(t('common.logout') + '?')) {
        if (isTrainingMode()) {
            disableTrainingMode();
        }
        clearAllManagedData();
        window.location.href = `${rootPrefix}login.html`;
    }
}

function setChangePasswordFormDisabled(disabled) {
    const form = document.getElementById('changePasswordForm');
    if (!form) return;

    form.querySelectorAll('input, button').forEach(element => {
        element.disabled = disabled;
    });

    const submitBtn = document.getElementById('changePasswordSubmitBtn');
    if (submitBtn) {
        submitBtn.textContent = disabled ? '儲存中...' : '儲存';
    }
}

function resetChangePasswordForm() {
    const form = document.getElementById('changePasswordForm');
    if (form) {
        form.reset();
    }
}

function getChangePasswordModal() {
    const modalElement = document.getElementById('changePasswordModal');
    if (!modalElement || !window.bootstrap?.Modal) {
        return null;
    }
    return window.bootstrap.Modal.getOrCreateInstance(modalElement);
}

async function handleChangePasswordSubmit(event) {
    event.preventDefault();

    const oldPassword = document.getElementById('oldPasswordInput')?.value || '';
    const newPassword = document.getElementById('newPasswordInput')?.value || '';
    const confirmNewPassword = document.getElementById('confirmNewPasswordInput')?.value || '';

    if (!oldPassword || !newPassword || !confirmNewPassword) {
        showErrorToast('請完整輸入舊密碼與新密碼。');
        return;
    }

    if (newPassword !== confirmNewPassword) {
        showErrorToast('新密碼與確認新密碼不一致。');
        return;
    }

    const managerID = getManagerID();
    const token = getManagerToken();

    if (!managerID || !token) {
        showErrorToast(t('apiError.sessionExpired'));
        window.location.href = `${rootPrefix}login.html`;
        return;
    }

    setChangePasswordFormDisabled(true);

    try {
        const result = await managerApi.updateManagerPassword(managerID, token, oldPassword, newPassword);
        const apiError = result?.error;

        if (apiError && apiError.errorCode !== '') {
            showErrorToast(apiError.errorMessage || '修改密碼失敗。');
            return;
        }

        showSuccessToast('密碼已更新。');
        resetChangePasswordForm();
        getChangePasswordModal()?.hide();
    } catch (error) {
        console.error('Update manager password error:', error);
        showErrorToast(error.message || '修改密碼失敗，請稍後再試。');
    } finally {
        setChangePasswordFormDisabled(false);
    }
}

export function initializeChangePasswordMenu() {
    const menuItem = document.getElementById('change-password-menu-item');
    const form = document.getElementById('changePasswordForm');
    const modalElement = document.getElementById('changePasswordModal');

    if (menuItem) {
        menuItem.addEventListener('click', () => {
            resetChangePasswordForm();
            getChangePasswordModal()?.show();
        });
    }

    if (form) {
        form.addEventListener('submit', handleChangePasswordSubmit);
    }

    if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', resetChangePasswordForm);
    }
}

